import * as yup from 'yup';

import validations from 'src/utils/validations';

export default yup.object().shape({
  name: validations.givenName.optional,
  role: validations.selector.optional(),
  active: yup.boolean()
});
